<template>
  <div>
    <div class='text-right lg:text-left'>
      <span :class="['status-marker', color]">
        <span v-if='statusMessage'>{{ statusMessage }}</span>
        <span v-else class='text-[#BABBC2]'>{{ locales && locales.property && locales.property.inactive }}</span>
      </span>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    props: ['status'],
    computed: {
      ...mapGetters(['metadata', 'locales']),
      color() {
        let colorMap = {
          'new': 'status-marker--green',
          'active': 'status-marker--green',
          'option': 'status-marker--green',
          'tophouse': 'status-marker--green',
          'lower_price': 'status-marker--green',
          'recommended': 'status-marker--green',
          'send_to_searchprofiles': 'status-marker--orange',
          'soon': 'status-marker--orange',
          'rented_by_owner': 'status-marker--orange',
          'rented_by_us': 'status-marker--orange',
          'concept_in_progress': 'status-marker--orange',
          'concept_new': 'status-marker--orange',
          'archived': 'status-marker--gray',
          'archived_rented_by_us': 'status-marker--gray',
          'archived_rented_by_landlord': 'status-marker--gray',
        };
        return this.status && this.status.attribute && this.status.attribute.slug ? colorMap[this.status.attribute.slug] : 'status-marker--gray';
      },
      statusMessage() {
        return this.status && this.status.value;
      },
    },
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/ManagePropertiesStatus.vue